import { useRef, useState } from 'react';
import { navItems } from './../static/data';
import { Link, useNavigate } from 'react-router-dom'; // useNavigate'i import ediyoruz
import { useSelector } from 'react-redux';
import myAudioFile from '../assets/mp3/KitaroCaravansary(live).mp3';
const Header = ({ active }) => {
    const [menuOpen, setMenuOpen] = useState(false);
    const { user } = useSelector((state) => state.admin);
    const navigate = useNavigate(); // useNavigate hook'unu kullanarak yönlendirme işlemlerini gerçekleştireceğiz.

    const audioRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const handlePlay = () => {
        const audioElement = audioRef.current;
        audioElement.play().then(() => {
            setIsPlaying(true);
        }).catch(error => console.error("Audio play error:", error));
    };

    const handleAdminClick = () => {
        navigate('/dashboard'); // dashboard sayfasına yönlendirme
    };

    return (
        <div className="bg-black text-white">
            <div className="flex items-center px-1 py-1">
                <div className="flex items-center"> {/* Logo ve simgeyi sola dayalı */}
                    <Link
                        to={"/"}
                        onClick={isPlaying ? null : handlePlay}
                        className={`justify-start mx-1 my-1 ${active ? 'text-[#17dd1f]' : 'text-white'} font-semibold`}
                    >
                        <audio ref={audioRef} src={myAudioFile} loop />
                        <img
                            src="https://res.cloudinary.com/dafvzct6j/image/upload/v1714995470/gurgenassets/z8kgtu65rwqykwqlsrvq.svg"
                            className="justify-start w-54 h-auto max-w-full max-h-20"
                            alt=""
                        />
                    </Link>
                    <div className="block justify-end items-center lg:hidden">
                        <button
                            onClick={() => setMenuOpen(!menuOpen)}
                            className="text-white hover:text-[#17dd1f]"
                            aria-label="Menu"
                        >
                            <svg
                                className="w-10 h-10 justify-end items-center"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M4 6h16M4 12h16m-7 6h7"
                                />
                            </svg>
                        </button>
                    </div>
                </div>
                <div className="hidden lg:flex lg:text-[16px] xl:text-[18px] 2xl:text-xl 3xl:text-3xl items-center justify-center">
                    {navItems.map((item, index) => (
                        <Link
                            key={index}
                            to={item.url}
                            className={`px-4 py-3 ${active === index + 1 ? 'text-[#17dd1f]' : 'text-white'} font-semibold`}
                        >
                            {item.title}
                        </Link>
                    ))}
                </div>
                {user && ( // Eğer kullanıcı varsa, "Admin" butonu gösterilecek
                    <button
                        onClick={handleAdminClick}
                        className="hidden lg:flex lg:ml-auto lg:mr-4 px-4 py-2  bg-gray-500 text-black font-semibold rounded hover:bg-gray-600 transition duration-200"
                    >
                        Admin
                    </button>
                )}
            </div>
            {menuOpen && (
                <div className="lg:hidden">
                    {navItems.map((item, index) => (
                        <Link
                            key={index}
                            to={item.url}
                            className={`block px-2 py-2 ${active === index + 1 ? 'text-[#17dd1f]' : 'text-white'} font-semibold text-lg`}
                            onClick={() => setMenuOpen(false)}
                        >
                            {item.title}
                        </Link>
                    ))}
                    {user && ( // Eğer kullanıcı varsa, "Admin" butonu gösterilecek
                        <button
                            onClick={handleAdminClick}
                            className="block w-full text-left px-2 py-2 text-lg bg-gray-500 text-black font-semibold rounded hover:bg-gray-600 transition duration-200"
                        >
                            Admin
                        </button>
                    )}
                </div>
            )}
        </div>
    );
};

export default Header;
